export const BUSINESS_PROCESS_STATUSES = {
  ACTIVE: 1,
  NOT_ACTIVE: 0,
};
